import { EquipmentEnterprise } from './../../../shared/enums/equipment-enterprise';
import { GroupedId } from 'src/app/shared/enums/grouped-id.enum';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GroupEnum} from 'src/app/shared/enums/group.enum';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'real-time-info-window',
  templateUrl: './info-window.component.html',
  styleUrls: ['./info-window.component.scss']
})
export class InfoWindowComponent {

	@Input() data: any[] = [];
	@Input() dataMetrics: any[] = [];
	@Input() show: boolean = false;
	@Output() showChange = new EventEmitter<boolean>();

	selectedDevicesByName: Array<any> = []
	dialog = false;
	videoDisplay = false;
	isInfoWindowOpen = false;
  urlVideo = '';
  GroupEnum = GroupEnum;
	selectedDeviceName: string = '';

	indexVideo!: number;

	constructor(
    private messageService: MessageService
  ) {

	}


	ngOnInit() {
	}

  loadDataCamUrl(){
    this.data.forEach((e, i) => {
      const found = this.dataMetrics.find((d) => d.deviceName  === e.name);
      if(found !== undefined){
        this.data[i].streetName = found.streetName;
        this.data[i].groupId = found.groupId;
        this.data[i].latitude = found.latitude;
        this.data[i].longitude = found.longitude;
      }
    })
  }

  openEquipmentLocation(item: any): void {
    const latitude = Number(item?.latitude);
    const longitude = Number(item?.longitude);
    const hasValidLatitude = item?.latitude !== null && item?.latitude !== undefined
      && String(item.latitude).trim() !== '' && Number.isFinite(latitude) && latitude >= -90 && latitude <= 90;
    const hasValidLongitude = item?.longitude !== null && item?.longitude !== undefined
      && String(item.longitude).trim() !== '' && Number.isFinite(longitude) && longitude >= -180 && longitude <= 180;

    if (!hasValidLatitude || !hasValidLongitude) {
      this.messageService.add({
        key: 'toastError',
        severity: 'warn',
        summary: 'Localização indisponível',
        detail: 'Não foi possível localizar o equipamento porque latitude ou longitude não estão disponíveis.',
      });
      return;
    }

    window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, '_blank', 'noopener,noreferrer');
  }

	openVideo(index: number) {
    this.indexVideo = index;
		setTimeout(() => {
      this.videoDisplay = true;
		},10);
	}

	closeInfoDialog() {
		this.dialog = false;
		this.showChange.emit(false);
	}

	async showDialog(deviceName: string) {
		this.selectedDevicesByName = this.dataMetrics.filter((d) => d.deviceName  === deviceName);
		setTimeout(() => {
			this.dialog = true;
		},10);
	}

  isButtonEnabled(item: any): boolean {

    const deviceMetric = this.dataMetrics.find((d) => d.deviceName === item.name);
    const statusOnline = deviceMetric?.statusOnline;

    return !!(item?.equipmentSshPort && statusOnline !== 0);
  }

  getButtonTooltip(item: any): string {
    const deviceMetric = this.dataMetrics.find((d) => d.deviceName === item.name);
    const statusOnline = deviceMetric?.statusOnline;
    const enterprise = item?.enterprise?.toLowerCase();

    if (statusOnline === 0) {
      return 'Nao foi possível acessar, equipamento está offline';
    }

    //Mensagem do tooltip deixando apenas a inicial do nome da empresa em maiúsculo caso não seja um equipamento Velsis
    if (enterprise !== EquipmentEnterprise.VELSIS.toLowerCase()) {
      return `Equipamento indisponível para acesso (${enterprise ? enterprise.replace(/^./, (s: string) => s.toUpperCase()) : ''})`;
    }

    if (!item?.equipmentSshPort) {
      return 'Equipamento sem porta de acesso configurada';
    }

    return '';
  }

  goToEquipment(item: any) {
    if (!item?.equipmentUrl || !item?.equipmentInterfacePort) {
      this.messageService.add({
        key: 'toastError',
        severity: 'error',
        summary: 'Erro',
        detail: 'Dados do equipamento não disponíveis',
      });
      return;
    }

    const url = `http://${item.equipmentUrl}:${item.equipmentInterfacePort}/rtm/login`;
    window.open(url, '_blank');
  }


}
